import { IBankSettingsState } from './bankSettingsContext';
import { BankSettingsActionsTypes, TBankSettingsAction } from './bankSettingsActions';

export const bankSettingsReducer = (state: IBankSettingsState, action: TBankSettingsAction): IBankSettingsState => {
	switch (action.type) {
		case BankSettingsActionsTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetchData,
			};
		case BankSettingsActionsTypes.SET_BANK_SETTINGS:
			return {
				...state,
				bankSettings: action.payload.bankSettings,
			};
		case BankSettingsActionsTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case BankSettingsActionsTypes.SET_FETCHED_ACQUIRERS:
			return {
				...state,
				fetchedAcquirers: action.payload.fetchedAcquirers,
			};
		case BankSettingsActionsTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case BankSettingsActionsTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
